/**
 * CheTuo Web — Auth API functions.
 * Reuses /api/shop-mobile/auth/* endpoints.
 */

import { apiClient, shopMobilePath } from './client';

export interface SmsLoginResponse {
  token: string;
  user: {
    id: string;
    phone: string;
    displayName: string | null;
    isSuperAdmin: boolean;
  };
}

export interface SendSmsCodeResponse {
  requestId: string;
}

export function sendSmsCode(phone: string, deviceId?: string): Promise<SendSmsCodeResponse> {
  return apiClient.post<SendSmsCodeResponse>(
    shopMobilePath('/auth/sms-code'),
    { phone, scene: 'admin_login', deviceId },
  );
}

export function smsLogin(phone: string, code: string, deviceId?: string): Promise<SmsLoginResponse> {
  return apiClient.post<SmsLoginResponse>(
    shopMobilePath('/auth/sms-login'),
    { phone, code, deviceId },
  );
}

export function passwordLogin(phone: string, password: string, deviceId?: string): Promise<SmsLoginResponse> {
  return apiClient.post<SmsLoginResponse>(
    shopMobilePath('/auth/password-login'),
    { phone, password, deviceId },
  );
}
